import axios from "axios";
import { environment } from './environment'
import { saveAs } from 'file-saver';
const endpoint = environment.serverUrl;

export async function GetStoreLocations(storeUrl) {
    return await axios
        .get(endpoint + '/api/Store/locations?storeUrl='+storeUrl)
        .then(function (response) {
            if (response.status === 200 && response !== null && response !=="") {
                return response.data
            } else {
                return null
            }
        })
        .catch(function (error) {
            return null
        })
}

export async function AuthUrl(shopUrl,type) {
    return axios
    .get(endpoint+'/api/Store/get-auth-url?storeUrl=' + shopUrl + '&type=' + type)
    .then(function(response) {
      // console.log(response)
      if (response.status === 200 && response != null) {
        var data = response.data
        return data
      } else {
        throw new Error('Empty data')
      }
    })
    .catch(function(error) {
      console.log(error)
      return [] // Return empty array in case error response.
    })
  }

//   export async function PageAuthUrl(shopUrl) {
//     return axios
//     .get(endpoint+'/api/Store/get-page-auth-url?storeUrl=' + shopUrl)
//     .then(function(response) {
//       // console.log(response)
//       if (response.status === 200 && response != null) {
//         var data = response.data
//         return data
//       } else {
//         throw new Error('Empty data')
//       }
//     })
//     .catch(function(error) {
//       console.log(error)
//       return [] // Return empty array in case error response.
//     })
//   }

//   export async function CustomerAuthUrl(shopUrl) {
//     return axios
//     .get(endpoint+'/api/Store/get-customer-auth-url?storeUrl=' + shopUrl)
//     .then(function(response) {
//       // console.log(response)
//       if (response.status === 200 && response != null) {
//         var data = response.data
//         return data
//       } else {
//         throw new Error('Empty data')
//       }
//     })
//     .catch(function(error) {
//       console.log(error)
//       return [] // Return empty array in case error response.
//     })
//   }

//   export async function MetaobjectAuthUrl(shopUrl) {
//     return axios
//     .get(endpoint+'/api/Store/get-metaobject-auth-url?storeUrl=' + shopUrl)
//     .then(function(response) {
//       // console.log(response)
//       if (response.status === 200 && response != null) {
//         var data = response.data
//         return data
//       } else {
//         throw new Error('Empty data')
//       }
//     })
//     .catch(function(error) {
//       console.log(error)
//       return [] // Return empty array in case error response.
//     })
//   }

//   export async function definitionsAuthUrl(shopUrl) {
//     return axios
//     .get(endpoint+'/api/Store/get-definitions-auth-url?storeUrl=' + shopUrl)
//     .then(function(response) {
//       // console.log(response)
//       if (response.status === 200 && response != null) {
//         var data = response.data
//         return data
//       } else {
//         throw new Error('Empty data')
//       }
//     })
//     .catch(function(error) {
//       console.log(error)
//       return [] // Return empty array in case error response.
//     })
//   }

//   export async function ordersAuthUrl(shopUrl) {
//     return axios
//     .get(endpoint+'/api/Store/get-orders-auth-url?storeUrl=' + shopUrl)
//     .then(function(response) {
//       // console.log(response)
//       if (response.status === 200 && response != null) {
//         var data = response.data
//         return data
//       } else {
//         throw new Error('Empty data')
//       }
//     })
//     .catch(function(error) {
//       console.log(error)
//       return [] // Return empty array in case error response.
//     })
//   }

//   export async function TranslationAuthUrl(shopUrl) {
//     return axios
//     .get(endpoint+'/api/Store/get-translations-auth-url?storeUrl=' + shopUrl)
//     .then(function(response) {
//       // console.log(response)
//       if (response.status === 200 && response != null) {
//         var data = response.data
//         return data
//       } else {
//         throw new Error('Empty data')
//       }
//     })
//     .catch(function(error) {
//       console.log(error)
//       return [] // Return empty array in case error response.
//     })
//   }

  export async function MainAuthUrl(shopUrl) {
    return axios
    .get(endpoint+'/api/Store/get-auth-url?storeUrl=' + shopUrl)
    .then(function(response) {
      // console.log(response)
      if (response.status === 200 && response != null) {
        var data = response.data
        return data
      } else {
        throw new Error('Empty data')
      }
    })
    .catch(function(error) {
      console.log(error)
      return [] // Return empty array in case error response.
    })
  }

  

  export async function ChargeUrl(shopUrl, planTier = 'Pro') {
    return axios
    .get(endpoint+'/api/Store/charge-url?storeUrl=' + shopUrl + '&planTier=' + planTier)
    .then(function(response) {
      // console.log(response)
      if (response.status === 200 && response != null) {
        var data = response.data
        return data
      } else {
        throw new Error('Empty data')
      }
    })
    .catch(function(error) {
      console.log(error)
      return [] // Return empty array in case error response.
    })
  }

  export async function DeleteCharge(shopUrl) {
    return axios
    .delete(endpoint+'/api/Store/delete-charge?storeUrl=' + shopUrl)
    .then(function(response) {
      // console.log(response)
      if (response.status === 200 && response != null) {
        var data = response.data
        return data
      } else {
        throw new Error('Empty data')
      }
    })
    .catch(function(error) {
      console.log(error)
      return [] // Return empty array in case error response.
    })
  }

// export async function FileValidation(file) {
//     const formData = new FormData();
//     formData.append("file", file);
//     axios.post(endpoint+'/api/productCustom/file-validation',formData)
//     // // const response = await axios.post(endpoint+'/api/productCustom/file-validation',formData);
//     // // return response.data;

//     // return await axios
//     //     .post(endpoint+'/api/productCustom/file-validation',formData)
//     //     .then(function (response) {
//     //         if (response.status === 200 && response != null) {
//     //             //console.log("vendorList=",response.data)
//     //             return response.data
//     //         } else {
//     //             // throw new Error('Empty data')
//     //         }
//     //     })
//     //     .catch(function (error) {
//     //         console.log(error)
//     //         // return []
//     //     })
// }

// export async function ProductsImport(file) {
//     const formData = new FormData();
//     formData.append("file", file);
//     return await axios
//         .post(endpoint+'/api/productCustom/products-import',formData)
//         .then(function (response) {
//             if (response.status === 200 && response != null) {
//                 //console.log("ProductsImport=",response.data)
//                 return response.data
//             } else {
//                 throw new Error('Empty data')
//             }
//         })
//         .catch(function (error) {
//             console.log(error)
//             return []
//         })
// }

export async function install() {
    //console.log("shopurl=",window.location.search)
    const response = await axios.get(endpoint+'/api/auth/install' + window.location.search);
    if(response.data !== true && response.data !==false)
    {
        //console.log("auth url=",response.data);
        window.open(response.data,"_top");
    }
    else if(response.data === false)
    {
    }
}

export async function filterProductList(storeUrl,refresh) {
    return await axios
        .get(endpoint + '/api/Product/vendor-list?storeUrl='+storeUrl + '&refresh='+refresh)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                //console.log("vendorList=",response.data)
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return 
        })
}

export async function productSavedSearches(storeUrl) {
    return await axios
        .get(endpoint + '/api/Product/saved-searches?storeUrl='+storeUrl)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                //console.log("vendorList=",response.data)
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return 
        })
}

export async function getApikey() {
    return await axios
        .get(endpoint + '/api/Store/apikey')
        .then(function (response) {
            if (response.status === 200 && response != null) {
                //console.log("apikey=",response.data)
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return ""
        })
}

export async function productUploadStatus(storeUrl) {
    return await axios
        .get(endpoint + '/api/ProductCustom/upload-status?storeUrl='+storeUrl)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return null
        })
}

export async function productExpportStatus(storeUrl) {
    return await axios
        .get(endpoint + '/api/ProductCustom/export-status?storeUrl='+storeUrl)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return null
        })
}

export async function getStoreConfig(storeUrl) {
    return await axios
        .get(endpoint + '/api/StoreSettings?storeUrl='+storeUrl)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return null
        })
}

export async function getExportConfig(storeUrl,type) {
    return await axios
        .get(endpoint + '/api/StoreSettings/export-config?storeUrl='+storeUrl + '&type='+type)
        .then(function (response) {
            if (response.status === 200 && response !== null && response !=="") {
                return response.data
            } else {
                return null
            }
        })
        .catch(function (error) {
            return null
        })
}

export async function getProductImportHistory(storeUrl,pageNo, pageSize, importFormat) {
    return await axios
        .get(endpoint + '/api/ProductCustom/import-logs?storeUrl='+ storeUrl + '&pageNo='+pageNo + '&pageSize='+pageSize + '&importFormat='+importFormat)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return null
        })
}

export async function startImport(storeUrl,bulkId) {
    return await axios
        .post(endpoint + '/api/ProductCustom/start-import?storeUrl='+ storeUrl + '&bulkId='+bulkId)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            //console.log("import error=",error)
            throw new Error(error)
        })
}

export async function bulkPolling(storeUrl) {
    return await axios
        .get(endpoint + '/api/ProductCustom/bulk-polling?storeUrl='+ storeUrl)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return null
        })
}

export async function checkAnyBulkRunning(storeUrl) {
    return await axios
        .get(endpoint + '/api/ProductCustom/check-active-bulk?storeUrl='+ storeUrl)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return null
        })
}

export async function checkProductVariantCount(storeUrl) {
    return await axios
        .get(endpoint + '/api/ProductCustom/product-variant-count?storeUrl='+ storeUrl)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return null
        })
}

export async function AddStoreConfig(config,storeUrl) {
    return await axios
        .post(endpoint+'/api/StoreSettings?&storeUrl='+storeUrl,config)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return []
        })
}



export async function bulkCancel(storeUrl, bulkId, operationId = null) {
    let url = endpoint + "/api/ProductCustom/bulk-cancel?storeUrl=" + storeUrl;
    if (operationId) {
        url += "&operationId=" + operationId;
    } else if (bulkId) {
        url += "&bulkId=" + bulkId;
    } else {
        console.error("Either operationId or bulkId must be provided");
        return { error: "No operation identifier provided" };
    }
    
    return await axios
        .post(url)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return []
        })
}

export async function downloadBulkResult(storeUrl, bulkId, type) {
    try {
        const response = await axios.get(endpoint + "/api/ProductCustom/download-bulk-result?storeUrl=" + storeUrl + "&bulkId=" + bulkId + "&type=" + type, {
            responseType: "blob",
        });
        if (response.status >= 200 && response.status < 300) {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: "text/plain" }));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "result-" + storeUrl + "-" + type + ".csv");
            document.body.appendChild(link);
            link.click();
        } else {
            throw new Error("Failed to download the file.");
        }
    } catch (error) {
    }
}
  

export async function DeleteLogs(storeUrl) {
    return await axios
        .delete(endpoint+'/api/ProductCustom/delete-older-logs?storeUrl=' +storeUrl)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return []
        })
}

export async function ResumePendingImports(storeUrl) {
    return await axios
        .post(endpoint+"/api/ProductCustom/resume-pending-imports-store?storeUrl=" +storeUrl)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return []
        })
}



export async function exportByVendor(vendor) {

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
    };
    fetch(endpoint + '/api/Product/export-products-by-vendor-new?vendor=' + vendor, requestOptions)
        .then(response => {
            if (response.status === 200 && response !== null) {
                return response.blob().then((blob) => {
                    // var date = new Date(Date().toLocaleString());
                    const fileName = "products" + "_" + new Date().toLocaleString() + "" + '.csv';
                    saveAs(blob, fileName);
                    return response.statusText
                });
            }
            else if (response.status === 400) {
                return response.statusText
            }
        })
        .catch(error => {
            return []
        })
}

export async function installUsingShop(shop) {
    // //console.log("shopurl=",shop)
    const response = await axios.get(endpoint+'/api/auth/install?shop='+shop);
    // //console.log("auth url=",response);
    if(response.data !== true && response.data !== false)
    {
        // //console.log("auth url=",response.data);
        window.open(response.data,"_top");
    }
    else if(response.data === false)
    {
        // console.log("res url=",response.data);
        window.open("https://"+shop+"/admin/apps/bulk-transporter/verify-shop","_top");
    }
    return true;
}

export async function queryString() {
    var queryString = window.location.search;
    return queryString;
}

export function getShopUrl()
{
    var queryString = window.location.search;
    var shop = new URLSearchParams(queryString).get("shop");
    return shop;
}



///// ******************************Customer services ***************************//////////

export async function downloadCustomerBulkResult(storeUrl,bulkId,type) {
    try {
      const response = await axios.get(endpoint+"/api/Customer/download-bulk-result?storeUrl=" +storeUrl + "&bulkId="+bulkId +"&type=" + type, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "text/plain" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "result-"+storeUrl+"-"+type+".csv");
      document.body.appendChild(link);
      link.click();
    } catch (error) {
        console.error(error);
    }
  };

  export async function customerBulkCancel(storeUrl,bulkId) {
    return await axios
        .post(endpoint+"/api/Customer/bulk-cancel?storeUrl=" +storeUrl + "&bulkId="+bulkId)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return []
        })
}

export async function CustomerBulkPolling(storeUrl) {
    return await axios
        .get(endpoint + '/api/Customer/bulk-polling?storeUrl='+ storeUrl)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return null
        })
}

export async function DeleteCustomerLogs(storeUrl) {
    return await axios
        .delete(endpoint+'/api/Customer/delete-older-logs?storeUrl=' +storeUrl)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return []
        })   
}

export async function getCustomerImportHistory(storeUrl,pageNo, pageSize) {
    return await axios
        .get(endpoint + '/api/Customer/import-logs?storeUrl='+ storeUrl + '&pageNo='+pageNo + '&pageSize='+pageSize)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return null
        })
}

export async function customerExportStatus(storeUrl) {
    return await axios
        .get(endpoint + '/api/Customer/export-status?storeUrl='+storeUrl)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return null
        })
}

// export async function processCustomerCsv(fileUrl,storeUrl) {
//     return await axios
//         .post(endpoint+"/api/Customer/process-csv?fileUrl=" +fileUrl + "&storeUrl="+storeUrl)
//         .then(function (response) {
//             if (response.status === 200 && response != null) {
//                 return response.data
//             } else {
//                 throw new Error('Empty data')
//             }
//         })
//         .catch(function (error) {
//             console.log(error)
//             return []
//         })
// }

export async function processCustomerCsv (fileUrl,storeUrl) {

    var data =  {
        fileUrl : fileUrl,
        storeUrl : storeUrl
    }
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    };
    fetch(endpoint+"/api/Customer/process-csv", requestOptions)
        .then(response => {
            if (response.status === 200 && response !== null) {
                return response.statusText
            }
            else if (response.status === 400) {
                return response.statusText
            }
        })
        .catch(error => {
            return []
        })
}


// export async function processCustomerCsv (fileUrl,storeUrl)  {
//     try {
//         const response = await axios.post(`${endpoint}/process-csv`, {
//           fileUrl: csvData,
//           storeUrl: storeUrl
//         });
//         return response.data;
//       } catch (error) {
//     }
//   };
/// customer services end ////////


///// ******************************Collection services ***************************//////////


export async function downloadCollectionBulkResult(storeUrl,bulkId,type) {
    try {
      const response = await axios.get(endpoint+"/api/Collection/download-bulk-result?storeUrl=" +storeUrl + "&bulkId="+bulkId +"&type=" + type, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "text/plain" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "result-"+storeUrl+"-"+type+".csv");
      document.body.appendChild(link);
      link.click();
    } catch (error) {
        console.error(error);
    }
  };

  export async function collectionBulkCancel(storeUrl,bulkId) {
    return await axios
        .post(endpoint+"/api/ProductCustom/bulk-cancel?storeUrl=" +storeUrl + "&bulkId="+bulkId)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return []
        })
}

export async function CollectionBulkPolling(storeUrl) {
    return await axios
        .get(endpoint + '/api/Collection/bulk-polling?storeUrl='+ storeUrl)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return null
        })
}

export async function DeleteCollectionLogs(storeUrl) {
    return await axios
        .delete(endpoint+'/api/Collection/delete-older-logs?storeUrl=' +storeUrl)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return []
        })   
}

export async function getCollectionImportHistory(storeUrl,pageNo, pageSize) {
    return await axios
        .get(endpoint + '/api/Collection/import-logs?storeUrl='+ storeUrl + '&pageNo='+pageNo + '&pageSize='+pageSize)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return null
        })
}

export async function collectionExportStatus(storeUrl) {
    return await axios
        .get(endpoint + '/api/Collection/export-status?storeUrl='+storeUrl)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return null
        })
}

///// ******************************Collection services End ***************************//////////

export async function PageExportStatus(shopUrl) {
    return axios
    .get(endpoint+'/api/Page/export-status?storeUrl=' + shopUrl)
    .then(function(response) {
      // console.log(response)
      if (response.status === 200 && response != null) {
        var data = response.data
        return data
      } else {
        throw new Error('Empty data')
      }
    })
    .catch(function(error) {
      console.log(error)
      return [] // Return empty array in case error response.
    })
  }

  export async function pauseMetafieldDeleteQueue(shopUrl) {
    return axios
    .post(endpoint+'/api/Queue/pause-meta-delete-queue?shopUrl=' + shopUrl)
    .then(function(response) {
      // console.log(response)
      if (response.status === 200 && response != null) {
        var data = response.data
        return data
      } else {
        throw new Error('Empty data')
      }
    })
    .catch(function(error) {
      console.log(error)
      return [] // Return empty array in case error response.
    })
  }


  export async function getMappedTemplates(storeUrl,importType) {
    return axios
    .get(endpoint+'/api/TemplateMap?storeUrl=' + storeUrl + '&importType=' + importType)
    .then(function(response) {
      // console.log(response)
      if (response.status === 200 && response != null) {
        var data = response.data
        return data
      } else {
        throw new Error('Empty data')
      }
    })
    .catch(function(error) {
      console.log(error)
      return [] // Return empty array in case error response.
    })
  }

export async function getTemplateByPagination(storeUrl, pageNo, pageSize, importType) {
    return axios
        .get(endpoint + '/api/TemplateMap/templates?storeUrl=' + storeUrl  + '&pageNo=' + pageNo + '&pageSize=' + pageSize + '&importType=' + importType)
        .then(function (response) {
            // console.log(response)
            if (response.status === 200 && response != null) {
                var data = response.data
                return data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return [] // Return empty array in case error response.
        })
}

export async function deleteTemplateById(storeUrl, templateId) {
    return axios
        .delete(endpoint + '/api/TemplateMap?storeUrl=' + storeUrl + '&templateId=' + templateId)
        .then(function (response) {
            // console.log(response)
            if (response.status === 200 && response != null) {
                var data = response.data
                return data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            return [] // Return empty array in case error response.
        })
}

  //////////// check orevious export exists ////////

  
  export async function checkPrevExportExist(storeUrl,type) {
    return axios
    .get(endpoint+'/api/'+ type + '/prev-export-exist?storeUrl=' + storeUrl)
    .then(function(response) {
      // console.log(response)
      if (response.status === 200 && response != null) {
        var data = response.data
        return data
      } else {
        throw new Error('Empty data')
      }
    })
    .catch(function(error) {
      console.log(error)
      return [] // Return empty array in case error response.
    })
  }


export async function getRestoreHistory(storeUrl, pageNo, pageSize) {
    return await axios
        .get(endpoint + '/api/Backup/restore-history?storeUrl=' + storeUrl + '&pageNo=' + pageNo + '&pageSize=' + pageSize)
        .then(function (response) {
            if (response.status === 200 && response != null) {
                return response.data
            } else {
                throw new Error('Empty data')
            }
        })
        .catch(function (error) {
            console.log(error)
            // Check for 403 plan upgrade errors
            if (error.response && error.response.status === 403 && error.response.data?.requiresUpgrade) {
                return {
                    requiresUpgrade: true,
                    message: error.response.data.message,
                    results: [],
                    totalCount: 0
                }
            }
            return null
        })
}

  ////////////////////////////////////// integration configs /////////////////////
  
   export async function fetchScheduleCounts(storeUrl) {
  try {
      const response = await axios.get(`${endpoint}/api/Integrations/config-count`, {
          params: { storeUrl }
      })
    console.log('Integration schedule counts:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching integration schedule counts:', error.message);
    throw error;
  }
}

////////////////////////////////////// Plan Authorization /////////////////////

/**
 * 
 * @param {string} storeUrl
 * @returns {Promise}
 */
export async function getPlanStatus(storeUrl) {
  try {
    const response = await axios.get(`${endpoint}/api/Store/plan-status`, {
      params: { storeUrl }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching plan status:', error);
    return {
      success: false,
      hasProPlan: false,
      isFreePlan: true,
      error: error.message
    };
  }
}

/**
 * Check if a specific feature is available for the store
 * @param {string} storeUrl - The store URL
 * @param {string} featureName - Feature name (e.g., 'MetafieldManagement', 'BulkOperations')
 * @returns {Promise} Feature access status
 */
export async function checkFeatureAccess(storeUrl, featureName) {
  try {
    const response = await axios.get(`${endpoint}/api/Store/check-feature`, {
      params: { storeUrl, featureName }
    });
    return response.data;
  } catch (error) {
    console.error(`Error checking feature ${featureName}:`, error);
    return {
      success: false,
      isAllowed: false,
      requiresUpgrade: true,
      reason: 'Unable to verify feature access. Please try again.'
    };
  }
}

/**
 * Handles API errors and checks if upgrade is needed
 * @param {object} error - Axios error object
 * @returns {object} Processed error info
 */
export function handlePlanError(error) {
  if (error.response && error.response.status === 403) {
    const data = error.response.data;
    if (data.requiresUpgrade) {
      return {
        needsUpgrade: true,
        message: data.message || 'This feature requires a Pro plan subscription.',
        feature: data.feature
      };
    }
  }
  return {
    needsUpgrade: false,
    message: error.message || 'An error occurred'
  };
}

/**
 * Get trial status for the store
 * @param {string} storeUrl - The store URL
 * @returns {Promise} Trial status information
 */
export async function getTrialStatus(storeUrl) {
  try {
    const response = await axios.get(`${endpoint}/api/Store/trial-status`, {
      params: { storeUrl }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching trial status:', error);
    return {
      success: false,
      isTrialExpired: true,
      remainingTrialDays: 0,
      hasActiveCharge: false,
      canAccessApp: false,
      error: error.message
    };
  }
}